"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _hooks = require("../hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// This works analogously to useKintIntl's "formatKintMessage"
const FormattedKintMessage = _ref => {
  let {
    fallbackMessage,
    id,
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    overrideValue,
    ...formattedMessageProps
  } = _ref;
  const intlKey = (0, _hooks.useIntlKey)(passedIntlKey, passedIntlNS);
  const intlObj = (0, _reactIntl.useIntl)();
  if (overrideValue) {
    // Version 3 is a breaking change, where labelOverrides must be strings.
    if (typeof overrideValue !== 'string') {
      throw new Error('Override values must be strings as of stripes-kint-components ^3.0.0');
    }
    if (intlObj.messages?.[overrideValue]) {
      // We've been passed a key as an override, return formattedMessage with it
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: overrideValue,
        ...formattedMessageProps
      });
    }
    // At this stage we have an overrideValue that's not a key, return it.
    return overrideValue;
  }

  // If key does not exist in intl, and we have a specified "fallbackMessage", use that

  // (FallbackMessage works like defaultMessage but with no warning)
  if (!intlObj.messages?.[`${intlKey}.${id}`] && fallbackMessage) {
    // Allow fallback message to be an intl key
    if (intlObj.messages?.[fallbackMessage]) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: fallbackMessage,
        ...formattedMessageProps
      });
    }
    return fallbackMessage;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
    id: `${intlKey}.${id}`,
    ...formattedMessageProps
  });
};
FormattedKintMessage.propTypes = {
  fallbackMessage: _propTypes.default.string,
  id: _propTypes.default.string.isRequired,
  intlKey: _propTypes.default.string,
  intlNS: _propTypes.default.string,
  overrideValue: _propTypes.default.string
};
var _default = exports.default = FormattedKintMessage;